import { bureauAxios } from './bureauBase'


//排班报表详情
function operationSchedulingReport(params) {
    let tempUrl = '/api/operationScheduling/operationSchedulingReport';
    return bureauAxios(tempUrl, 'get',params);
}


export default {
    operationSchedulingReport
}
